import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { CTASection } from "../components/CTASection";
import { SERVICES } from "../data/site";

export default function Services() {
  return (
    <>
      <PageHeader
        eyebrow="Hizmetlerimiz"
        titleLines={["Uçtan uca enerji", "mühendisliği."]}
        description="Fizibiliteden kuruluma, işletmeden bakıma kadar güneş enerjisi ve elektrifikasyon alanında sunduğumuz sekiz temel hizmet."
      />

      <section data-testid="services-bento" className="relative bg-[#0A0A0A] pb-24 sm:pb-32">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 auto-rows-[minmax(220px,auto)]">
            {SERVICES.map((s, i) => {
              const Icon = s.icon;
              const hasImage = Boolean(s.image);
              return (
                <Reveal key={s.id} delay={(i % 3) * 0.08} className={s.span}>
                  <div
                    data-testid={`service-card-${s.id}`}
                    className="group relative h-full overflow-hidden rounded-3xl bg-[#121212] border border-white/10 hover:border-[#5CC528]/40 transition-colors duration-300"
                  >
                    {hasImage && (
                      <>
                        <img
                          src={s.image}
                          alt={s.title}
                          className="absolute inset-0 w-full h-full object-cover opacity-40 group-hover:opacity-55 group-hover:scale-105 transition-[opacity,transform] duration-700"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/70 to-transparent" />
                      </>
                    )}
                    <div className="relative h-full p-8 flex flex-col justify-between min-h-[220px]">
                      <div className="w-12 h-12 rounded-xl bg-[#5CC528]/15 backdrop-blur flex items-center justify-center group-hover:bg-[#5CC528] transition-colors duration-300">
                        <Icon size={22} className="text-[#5CC528] group-hover:text-black transition-colors duration-300" />
                      </div>
                      <div>
                        <div className="text-xs uppercase tracking-[0.15em] text-[#5CC528] mb-2">{s.short}</div>
                        <h3 className="font-display font-semibold text-2xl sm:text-3xl tracking-tight text-white mb-3">{s.title}</h3>
                        <p className="text-sm text-neutral-300 leading-relaxed max-w-md">{s.desc}</p>
                      </div>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      <CTASection />
    </>
  );
}
